import { DateFieldFilter } from 'module/types/filter-field/filter/date';
import { format } from 'module/ui/components/molecules/field-filter/criteria/date/format';
import { startCase } from 'lodash';
import { FC } from 'react';

export const DateFilterToText: FC<
  React.PropsWithChildren<{ filter: DateFieldFilter }>
> = ({ filter }) => {
  const {
    field: { fieldLabel },
  } = filter;

  return (
    <span>
      {startCase(fieldLabel)} {format(filter)}
    </span>
  );
};
